import { z } from "zod";
import { MIN_SERVICE_AREA_RADIUS } from "../ConfigCalendarSetList.constants";

export const configCalendarSetSchema = z.object({
  name: z.string().min(1, "Calendar Name is required."),
  calendarConfigs: z.array(
    z
      .object({
        name: z.string().trim().min(1, "Calendar Name is required."),
        calendarType: z.string().min(1, "Calendar Type is required."),
        followUpDisplay: z.string().min(1, "Selection is required."),
        followUpDefaultOffsetHours: z
          .string()
          .trim()
          .min(1, "Default Follow-Up Delay is required."),

        followUpMaxOffsetHours: z
          .string()
          .trim()
          .min(1, "Maximum Follow-Up Delay is required."),
      })
      .refine(
        (data) =>
          data.followUpDefaultOffsetHours &&
          data.followUpMaxOffsetHours &&
          parseInt(data.followUpMaxOffsetHours, 10) >=
            parseInt(data.followUpDefaultOffsetHours, 10),
        {
          message: "Max Delay cannot be less than Default Delay",
          path: ["followUpMaxOffsetHours"],
        }
      )
  ),
  serviceAreas: z
    .array(
      z.object({
        city: z.string().trim().min(1, "City is required."),
        state: z.string().trim().min(1, "State is required."),
        radius: z
          .union([
            z.number().min(1, "Radius is required."),
            z.string().min(1, "Radius is required."),
          ])
          .refine((val) => {
            const parsed = typeof val === "number" ? val : parseFloat(val);
            return !Number.isNaN(parsed) && parsed >= MIN_SERVICE_AREA_RADIUS;
          }, `Radius must be at least ${MIN_SERVICE_AREA_RADIUS}`),
      })
    )
    .superRefine((items, ctx) => {
      const uniqueValues = new Set();

      items.forEach((item, index) => {
        const identifier = `${item.city.toLowerCase()}-${item.state.toLowerCase()}`;

        if (uniqueValues.has(identifier)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `Duplicate service area: ${item.city}, ${item.state}`,
            path: [index, "city"],
          });
        }

        uniqueValues.add(identifier);
      });
    }),
});
